import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconStaffSvg }  from '../../assets/icons/icon_staff_blue.svg';

const StaffIcon=(props)=>{
    return <Icon component={() => <IconStaffSvg />} {...props}/>
}

export default StaffIcon;